import _slicedToArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useLayoutEffect as e } from "@radix-ui/react-use-layout-effect";
import * as t from "react";

var r = t["useId".toString()] || function () {};

var i = 0;
export function useId(n) {
  var _t$useState = t.useState(r()),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      o = _t$useState2[0],
      s = _t$useState2[1];

  return e(function () {
    n || s(function (e) {
      return null != e ? e : String(i++);
    });
  }, [n]), n || (o ? "radix-".concat(o) : "");
}
export function IdProvider(_ref) {
  var e = _ref.children;
  return t.useEffect(function () {
    console.warn(n);
  }, []), /*#__PURE__*/t.createElement(t.Fragment, null, e);
}
var n = "Warning: The `IdProvider` has been deprecated. For details, see https://radix-ui.com/docs/primitives/utilities/id-provider";